/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Stack } from 'forms/FormStack'
import { ScrollablePane } from 'office-ui-fabric-react'
import * as React from 'react'

export const StickyPane: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Stack verticalFill={true}>
      <Stack.Item grow={true} css={css({ position: 'relative' })}>
        <ScrollablePane>{children}</ScrollablePane>
      </Stack.Item>
    </Stack>
  )
}
